import React from "react";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";

import RiskMembersModule from "./RiskMembers/index";
import NumberOfActiveMembersByModule from "./numberOfActiveMembersBy/index";
import MembershipBreakdownModule from "./membershipBreakdownChart/index";
import ItemsProcessedByMonthModule from "./RecurringRevenueByMonth/index";
import ZeroVisitMembersModule from "./ZeroVisitMembersChart/index";
import RecurringRevenueModule from "./RecurringRevenue/index";
import HeatmapModule from "./heatmap/index";
import AttritionAndCancelReasonsModule from "./attritionAndCancelReasons/index";

const pageConfig = {
  pageName: "Memberships",
  configuratorWidth: 470,
  moduleList: [
    NumberOfActiveMembersByModule,
    RiskMembersModule,
    MembershipBreakdownModule,
    ItemsProcessedByMonthModule,
    ZeroVisitMembersModule,
    RecurringRevenueModule,
    HeatmapModule,
    AttritionAndCancelReasonsModule
  ]
};

const MembershipPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default MembershipPage;
